import type { WorkflowTask } from './workflow-task.interface';

export interface cv_TaskType {
    Abbreviation: string;
    C_TaskType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    TaskType: string;
    Version: number;
    WorkflowTask: WorkflowTask[];
}
